module.exports = __webpack_public_path__ + "static/media/ctc_event.cb7e20da.jpg";